import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import CoffeeRoundedIcon from "@mui/icons-material/CoffeeRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import TimelapseRoundedIcon from "@mui/icons-material/TimelapseRounded";

const Dashboard = ({
  colorMode,
  totalTime,
  totalSavedTime,
  totalBooster,
  totalBreakTime,
}) => {
  const boosterTime = Number(totalBooster || 0) * 150;

  const formatTime = (time) => {
    const safeTime = Math.max(0, Number(time) || 0);
    const hours = String(Math.floor(safeTime / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((safeTime % 3600) / 60)).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const metrics = [
    {
      label: "Active",
      value: formatTime(totalTime),
      icon: AccessTimeRoundedIcon,
    },
    {
      label: "Saved",
      value: formatTime(totalSavedTime),
      icon: TimelapseRoundedIcon,
    },
    {
      label: "Boost",
      value: formatTime(boosterTime),
      icon: BoltRoundedIcon,
    },
    {
      label: "Break",
      value: formatTime(totalBreakTime),
      icon: CoffeeRoundedIcon,
    },
  ];

  return (
    <section
      className={`activity-summary ${colorMode ? "" : "is-dark"}`}
      aria-label="Activity summary"
    >
      <header className="activity-summary-header">
        <div>
          <h2>Activity summary</h2>
          <p>Today’s focus overview</p>
        </div>
        <span>HH:MM</span>
      </header>

      <div className="activity-summary-grid">
        {metrics.map((metric) => {
          const MetricIcon = metric.icon;

          return (
            <div className="activity-summary-metric" key={metric.label}>
              <span className="activity-summary-metric-icon">
                <MetricIcon />
              </span>
              <span className="activity-summary-metric-copy">
                <small>{metric.label}</small>
                <strong>{metric.value}</strong>
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Dashboard;
